import { render } from "./NameAndDescription.vue?vue&type=template&id=662b6d6b&scoped=true"
import script from "./NameAndDescription.vue?vue&type=script&lang=js"
export * from "./NameAndDescription.vue?vue&type=script&lang=js"

import "./NameAndDescription.vue?vue&type=style&index=0&id=662b6d6b&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-662b6d6b"]])

export default __exports__